<template>
    <model-selection-radio :characteristic="characteristic" :doorConfigurationProp="context" />
</template>
<script>
import Vue from 'vue'; 
import MSRadio from './MSRadio.vue';

export default Vue.extend({
    name: 'MSRadioContainer',        
    props: {
        characteristic: Object,
        context: Number,
        settingsContent: Number,
        settingsVal: Number,
    },
    components: {
        'model-selection-radio': MSRadio,
    },
})
</script>